import { format } from 'owa-strings';
import { ITEM_ID_URL } from '../utils/constants';
import { makeSDSNetworkCall } from './makeSDSNetworkCall';

/**
 * Service to update an item in a collection in SDS
 * @param collectionName Collection in which the item is to be updated
 * @param itemId ID of the item to be updated
 * @param body Key value pairs to be updated
 * unexpected errors which are reported: Please do not store EMPTY ARRAYS in SDS, it will throw an error saying CollectionTypeNameRequired
 */
export async function updateSDSCollectionItemWithId(
    collectionName: string,
    itemId: string,
    body: any
): Promise<any> {
    return makeSDSNetworkCall(format(ITEM_ID_URL, collectionName, itemId), 'PATCH', {
        ...body,
    });
}
